import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import cn from 'classnames'
import { NavLink } from 'react-router-dom'

import useMobileDetect from '../../hooks/useMobileDetect'
import { createSpaLink, getCurrentInstance } from 'utils/links'
import spas from 'utils/spas'
import { sidebarMenusItems } from 'utils/sidebarMenusItems'
import { logOutAndRedirect } from 'utils/auth'

import Dropdown from 'components/Dropdown'
import { signOut } from 'store/Auth/actions'
import { getVenues, getCurrentVenue } from 'store/Venues/selector'
import { getCurrentUserEmail } from 'store/Auth/selector'
import { ReactComponent as IconMenus } from 'assets/icons/applications/IconMenus.svg'
import { ReactComponent as IconLoyalty } from 'assets/icons/applications/IconLoyalty.svg'
import { ReactComponent as IconDevices } from 'assets/icons/applications/IconDevices.svg'
import { ReactComponent as IconRefund } from 'assets/icons/applications/IconRefund.svg'
import { ReactComponent as IconSuites } from 'assets/icons/applications/IconSuites.svg'
import { ReactComponent as IconReports } from 'assets/icons/applications/IconReports.svg'
import { ReactComponent as IconStatus } from 'assets/icons/applications/IconStatus.svg'
import { ReactComponent as IconOrders } from 'assets/icons/applications/IconOrders.svg'
import { ReactComponent as IconAccess } from 'assets/icons/applications/IconAccess.svg'
import { ReactComponent as IconSettings } from 'assets/icons/applications/IconSettings.svg'
import { ReactComponent as IconTriangle } from 'assets/icons/IconTriangle.svg'
import { selectVenue } from 'store/Venues/actions'

const Sidebar = ({ isOpen, toggleSidebarActive }) => {
  const dispatch = useDispatch()

  const [showDropdownMenu, setShowDropdownMenu] = useState(false)
  const { isMobile } = useMobileDetect()

  const currentVenue = useSelector(getCurrentVenue)
  const venues = useSelector(getVenues)
  const userEmail = useSelector(getCurrentUserEmail)

  const appsIcons = {
    menus: <IconMenus />,
    orders: <IconOrders />,
    status: <IconStatus />,
    reports: <IconReports />,
    refund: <IconRefund />,
    loyalty: <IconLoyalty />,
    devices: <IconDevices />,
    suites: <IconSuites />,
    access: <IconAccess />,
    settings: <IconSettings />,
  }

  const handleVenueChange = (id) => {
    dispatch(selectVenue(id))
  }

  const handleLogout = () => {
    dispatch(signOut())
    logOutAndRedirect()
  }

  const instanceName = getCurrentInstance(window.location.href)

  return (
    <aside className={cn('sidebar', { '-open': isOpen })}>
      <div className="sidebar__wrapper">
        <header className="sidebar__header">
          <Dropdown
            className="venue-select-dropdown"
            email={'userEmail'}
            handleClick={handleVenueChange}
            label={currentVenue.label}
            options={venues}
            selectedOption={currentVenue.value}
            setShowDropdownMenu={setShowDropdownMenu}
            showDropdownMenu={showDropdownMenu}
          />
        </header>
        <nav className="sidebar__navigation">
          <section className="sidebar__apps">
            {spas.map((spa, index) => {
              if (spa.name === 'devices') {
                return (
                  <Fragment key={index}>
                    <a
                      className="sidebar__item -active"
                      href={createSpaLink(spa.domain, spa.subdomain, instanceName)}
                      id={spa.name}
                    >
                      {appsIcons[spa.name]}
                      <span className="sidebar__menu-title">{spa.display_name}</span>
                      <IconTriangle />
                    </a>
                    <div className={cn('sidebar__sub-items -open')}>
                      {sidebarMenusItems.map((sidebarMenusItem) => (
                        <NavLink
                          activeClassName="-active"
                          className="sidebar__sub-item"
                          key={sidebarMenusItem.name}
                          onClick={isMobile ? toggleSidebarActive : null}
                          to={sidebarMenusItem.link}
                        >
                          <span className="sidebar__menu-title">{sidebarMenusItem.name}</span>
                        </NavLink>
                      ))}

                      <div className="sidebar__sub-item-separator"></div>
                    </div>
                  </Fragment>
                )
              }
              return (
                <Fragment key={index}>
                  <a
                    className="sidebar__item"
                    href={createSpaLink(spa.domain, spa.subdomain, instanceName)}
                    id={spa.name}
                  >
                    {appsIcons[spa.name]}
                    <span className="sidebar__menu-title">{spa.display_name}</span>
                  </a>
                </Fragment>
              )
            })}
          </section>
        </nav>
      </div>
      <div className="sidebar__info">
        <span className="sidebar__user-email">{userEmail}</span>
        <button className="sidebar__btn-logout" onClick={handleLogout} type="button">
          Log Out
        </button>
        <span className="sidebar__version-box">{process.env.REACT_APP_VERSION}</span>
      </div>
      <div
        className={cn('sidebar__overlay', { '-open': isOpen })}
        onClick={toggleSidebarActive}
      ></div>
    </aside>
  )
}

Sidebar.defaultProps = {
  toggleSidebarActive: () => {},
}

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleSidebarActive: PropTypes.func,
}

export default Sidebar
